export default function documentUploadFinished(loadState: number[]) {
  return loadState.every(item => item === 3);
}
